/**
 * @name objectValues
 * @summary A version of Object.values that is typed for TS
 */
export function objectValues(obj) {
    return Object.values(obj);
}
